import { formsInit } from "./modules/kw-forms";

(() => {
  const ms = 1;
  const second = 1000 * ms;
  const minute = 60 * second;

  // const DEBUG = true;

  const dialog = document.getElementById("kw-sendsay-popup");
  if (!dialog) return;
  dialog.onclick = (e) => {
    if (e.target.closest(".kw-sendsay-popup--body")) return;
    closeHandler();
  };

  function successHandler() {
    localStorage.setItem("sendsayPopupSuccess", "yes");
  }

  function closeHandler() {
    dialog.close();
    successHandler();
  }

  function getRandomArbitrary(min, max) {
    // if (DEBUG) return 0;
    return (Math.random() * (max - min) + min).toFixed(3);
  }

  // if (DEBUG || localStorage.getItem("sendsayPopupSuccess") !== "yes") {
  if (localStorage.getItem("sendsayPopupSuccess") !== "yes") {
    const timeout = getRandomArbitrary(3, 4);
    setTimeout(() => {
      dialog.showModal();
      formsInit(
        'dialog[data-name="kw-callback-form"]',
        "div.kw-sendsay-popup--main",
        successHandler,
      );
    }, timeout * minute);
  }
})();
